export default "__VITE_ASSET__Cdc8yEVW__"